export function dateStringToDate(dateString: string) {
  return new Date(dateString);
}

export function formatDate(date: Date) {
  return date.toLocaleDateString('en-US');
}

export function formatDatetimeStringToDatetime(datetimeString: string) {
  if (!datetimeString) {
    return '';
  }

  const formatter = new Intl.DateTimeFormat('en-US', {
    dateStyle: 'short',
    timeStyle: 'short'
  })

  return formatter.format(new Date(datetimeString));
}

export function dateStringToFormattedDate(dateString: string) {
  return formatDate(dateStringToDate(dateString));
}

const formatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
});
export function formatCurrency(value: number) {
  return formatter.format(value);
}
